<template>
  <modal
    :exibir="exibir"
    @fechar="fecharModal"
    titulo="Disciplinas"
    :campos="$refs"
    id="modalDisciplina"
  >
    <div class="row">
      <div class="col-12">
        <input-text
          ref="descricao"
          v-model="form.descricao"
          label="Disciplina"
          placeholder="Ex: História"
          required
        />
      </div>
      <div class="col-12">
        <b-row class="mt-3">
          <b-col>
            <input-checkbox
              :label="$t('GERAL.DISCIPLINA_VINCULAVEL')"
              v-model="form.vinculavelDisciplinaInterna"
              type="boolean"
            />
          </b-col>
        </b-row> 
      </div>
    </div>
    <template #modal-footer>
      <div class="d-flex justify-content-between w-100">
        <b-button variant="secondary" @click="fecharModal">
          {{ $t('GERAL.FECHAR') }}
        </b-button>
        <b-button variant="primary" @click="salvar">
          {{ $t('GERAL.SALVAR') }}
        </b-button>
      </div>
    </template>
  </modal>
</template>

<script>
// Utils & Aux:
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import mensagem from '@/common/utils/mensagem';
import helpers from '@/common/utils/helpers';
// Services:
import DisciplinaCurriculo from '@/common/services/curriculo-escolar/disciplina.service';
// Components:
import Modal from '@/components/modal/Modal.vue';
import InputCheckbox from '@/components/inputs/InputCheckbox.vue';
import { InputText } from '@/components/inputs';

export default {
  components: {
    Modal,
    InputText,
    InputCheckbox,
  },
  props: {
    exibir: { type: Boolean, default: false },
    form: { type: Object, default: Object },
  },
  data() {
    return {
      disciplinaSelecionada: '',
      vinculavelDisciplinaInterna: '',
    };
  },
  methods: {
    salvar() {
      if (!this.validarFormulario()) return;
      !this.form.id ? this.criar() : this.editar();
    },

    criar() {
      this.$store.dispatch(START_LOADING);
      DisciplinaCurriculo.criar(this.form)
        .then(({ data }) => {
          mensagem.sucesso(this.$t('GERAL.SUCESSO'), data.mensagem);
          this.disciplinaSelecionada = '';
          this.$emit('atualiza-tabela');
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.fecharModal();
          this.$store.dispatch(STOP_LOADING);
        });
    },

    editar() {
      this.$store.dispatch(START_LOADING);
      DisciplinaCurriculo.editar(this.form)
        .then(() => {
          mensagem.sucesso(this.$t('GERAL.SUCESSO'), 'Disciplina editada!');
          this.$emit('atualiza-tabela');
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.fecharModal();
          this.$store.dispatch(STOP_LOADING);
        });
    },
    
    fecharModal() {
      this.disciplinaSelecionada = null;
      this.$emit('fechar');
    },

    // funçoes aux
    validarFormulario() {
      return helpers.validarFormulario(this.$refs);
    },
  },
};
</script>
